//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import ProviderListView from '@/views/Purchase/PchProvider/list'
import ProviderUpdateView from '@/views/Purchase/PchProvider/update'

//
export default {
    path: 'providers',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'provider',
            component: ProviderListView,
        },
        {
            path: ':id',
            name: 'provider-update',
            component: ProviderUpdateView,
            meta: {
                title: 'Datos del proveedor',
            },
        },
    ],
    meta: {
        title: 'Proveedores',
    },
}
